import type { Nullable } from '@zenos/shared-types';

/**
 * Converts a string date to a Date object.
 * If the date is null, returns null.
 *
 * @example
 * ```js
 * toDate('2021-01-01') // new Date('2021-01-01')
 * toDate(null) // null
 * ```
 */
export function toDate(date: Nullable<string>) {
  return date ? new Date(date) : null;
}
